import './App.scss';
import './index.scss';

import { Suspense, useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { map } from 'lodash-es';
import { Provider } from 'react-redux';
import store from './Redux/store';
import {
  commonRouteMap,
  privateRouteMap,
  publicRouteMap,
  customerRouteMap,
  adminRouteMap,
} from './routes';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import CommonRoute from './routes/CommonRoute';
import AdminRoute from './routes/AdminRoute';
import CustomerRoute from 'routes/CustomerRoute';
import { app, db, auth } from './firebaseConfig';
import  jwtDecode  from "jwt-decode";

import { getMessaging, getToken } from 'firebase/messaging';
import { clearSessionData } from 'utils';
import PwaSignout from 'shared/pwaSignout/PwaSignout';

// import initMessaging from '/firebase-messaging-sw';

// import initMessaging from '../public/firebase-messaging-sw'

type Props = {};

const App = (props: Props) => {
  const [displayTimeout, setDisplayTimeout] = useState(false);
  const onClick = () => {
    clearSessionData();
    window.location.href = '/signin';
    setDisplayTimeout(false);
  };
  const checkSessionExpiry = () => {
    const token =
      localStorage.getItem('auth-storage') &&
      JSON.parse(localStorage.getItem('auth-storage'));

    const decodedToken = token?.state?.tokens?.idToken
      ? jwtDecode(token?.state?.tokens?.idToken?.jwtToken)
      : null;
    if (decodedToken) {
      //@ts-ignore

      const currentTimestamp = Math.floor(Date.now() / 1000); // Convert to seconds

      //@ts-ignore

      const tokenExpiration = decodedToken?.exp;
      // 1692608138
      if (currentTimestamp >= tokenExpiration) {
        // alert('Session has been expired');
        setDisplayTimeout(true);
        //@ts-ignore
      }
    }
  };
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);
  useEffect(() => {
    checkSessionExpiry();

    // Set up an interval to run the function every 30 minutes
    const interval = 1 * 60 * 1000; // 30 minutes in milliseconds
    const intervalId = setInterval(checkSessionExpiry, interval);

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <CircularProgress
              className='loading'
              disableShrink
              color='inherit'
            />
          }
        >
          <Switch>
            {map(commonRouteMap, (route) => (
              <CommonRoute
                key='commonRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}
            {
              /* we cannot use dynamic key value here, dynamic 'key' will cause the app to
                re-render as key changes its value. To avoid that, we are here using static value
                */
              map(publicRouteMap, (route) => (
                <PublicRoute
                  key='publicRouter'
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))
            }

            {map(customerRouteMap, (route) => (
              <CustomerRoute
                key='customerRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(privateRouteMap, (route) => (
              <PrivateRoute
                key='privateRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(adminRouteMap, (route) => (
              <AdminRoute
                key='adminRouter'
                exact
                path={route.path}
                component={route.component}
              />
            ))}
          </Switch>
        </Suspense>
      </Router>
      <PwaSignout show={displayTimeout} onClick={onClick} />
    </Provider>
  );
};

export default App;
